
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRadioDisabled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  textRendering: "geometricPrecision",
  viewBox: "0 0 24 24"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAASFBMVEXw8PC+vb+lpKevrrDm5uaqqayvrrHr6+vDwsSgn6LIx8nDw8Th4eHS0tOqqavc3N3h4OLc3NzS0dO+vcDc292+vr/IyMm+vsAc3VJxAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAf0lEQVR42r1RyxKEIAyjQF8Iurqr/v+f6kUojjN7k1MmaZkkde7F9xNUJYg3msVvJ5fLKNzxtPM1QVaRoeFVGo6jmWI/VQzF/pvaCmUrRKxQe4v6X8AuVg7NbbJCgQpnb+3afYHnsI7DVRF/Q1+W4PI5IyQ/8K3fCKSKMr156gOQkQLzWV5nwwAAAABJRU5ErkJggg==",
  width: 24,
  height: 24,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAASFBMVEXw8PC+vb+lpKevrrDm5uaqqayvrrHr6+vDwsSgn6LIx8nDw8Th4eHS0tOqqavc3N3h4OLc3NzS0dO+vcDc292+vr/IyMm+vsAc3VJxAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAf0lEQVR42r1RyxKEIAyjQF8Iurqr/v+f6kUojjN7k1MmaZkkde7F9xNUJYg3msVvJ5fLKNzxtPM1QVaRoeFVGo6jmWI/VQzF/pvaCmUrRKxQe4v6X8AuVg7NbbJCgQpnb+3afYHnsI7DVRF/Q1+W4PI5IyQ/8K3fCKSKMr156gOQkQLzWV5nwwAAAABJRU5ErkJggg==",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 24 24\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAASFBMVEXw8PC+vb+lpKevrrDm5uaqqayvrrHr6+vDwsSgn6LIx8nDw8Th4eHS0tOqqavc3N3h4OLc3NzS0dO+vcDc292+vr/IyMm+vsAc3VJxAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAf0lEQVR42r1RyxKEIAyjQF8Iurqr/v+f6kUojjN7k1MmaZkkde7F9xNUJYg3msVvJ5fLKNzxtPM1QVaRoeFVGo6jmWI/VQzF/pvaCmUrRKxQe4v6X8AuVg7NbbJCgQpnb+3afYHnsI7DVRF/Q1+W4PI5IyQ/8K3fCKSKMr156gOQkQLzWV5nwwAAAABJRU5ErkJggg==\" width=\"24\" height=\"24\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAASFBMVEXw8PC+vb+lpKevrrDm5uaqqayvrrHr6+vDwsSgn6LIx8nDw8Th4eHS0tOqqavc3N3h4OLc3NzS0dO+vcDc292+vr/IyMm+vsAc3VJxAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAf0lEQVR42r1RyxKEIAyjQF8Iurqr/v+f6kUojjN7k1MmaZkkde7F9xNUJYg3msVvJ5fLKNzxtPM1QVaRoeFVGo6jmWI/VQzF/pvaCmUrRKxQe4v6X8AuVg7NbbJCgQpnb+3afYHnsI7DVRF/Q1+W4PI5IyQ/8K3fCKSKMr156gOQkQLzWV5nwwAAAABJRU5ErkJggg==\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/radio-disabled.78f685723d3de3de0cb58d2285990501.svg"),
        {
          React: SvgRadioDisabled,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      